/**
 * Product Store
 * ----------------------------
 *
 *
 */
export const useProductStore = defineStore('product', () => {
    /**
     * Product List
     * ---------------------------------------------------
     */
    const products = ref<Product[]>([]);

    /**
     * Init new product. Creates product from factory,
     * adds product to store (replace existing product, leave others)
     */
    function initProduct(key: ProductKey, id: ProductId, productConfigPreset?: ProductConfigPreset, productPreset?: ProductPreset) {
        const { createProduct } = useProductFactory();
        const product = createProduct(
            key,
            id,
            productConfigPreset,
            productPreset,
        );

        products.value = [
            ...products.value.filter(p => p.id !== product.id),
            product,
        ];
    }

    /**
     * Init new upsell product. Creates product from factory (with parent product),
     * adds product to store (replace existing product, leave others)
     */
    function initUpsell(key: ProductKey, id: ProductId, upsellParent: Product) {
        const { createUpsell } = useProductFactory();
        const product = createUpsell(key, id, upsellParent);
        products.value = [
            ...products.value.filter(p => p.id !== product.id),
            product,
        ];
        return product;
    }

    /**
     * Edit Product. Replace existing product in store
     * with the given product (from cart)
     */
    function editProduct(product: Product) {
        products.value = [
            ...products.value.filter(p => p.id !== product.id),
            deepClone(product),
        ];
    }

    /**
     * Delete product completely from store
     * (e.g. when removing from cart). And remove depending upsells.
     *
     */
    function removeProduct(id: ProductId) {
        products.value = [
            ...products.value
                .filter(p => p.id !== id)
                .filter(p => p.upsellParent?.id !== id),
        ];
    }

    /**
     * Reset
     * ------------------------------------------------------------------------------------------
     */
    function reset() {
        products.value = [];
    }

    return {
        products,

        initProduct,
        initUpsell,
        editProduct,
        removeProduct,

        reset,
    };
}, {
    persist: {
        ...storePersist.storePersistOptions,
        key: 'product-v6',
    },
});
